import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, isOk, ok } from "@nju/result";
import { info } from "../info";
import { setAuthInfoInStorage } from "../setAuthIntoInStorage";
import { ILoginResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  actionToken: string;
}

export async function loginWithActionToken({
  actionToken,
}: IParams): Promise<ILoginResult> {
  const body = new URLSearchParams();
  body.append("grant_type", "urn:ietf:params:oauth:grant-type:token-exchange");
  body.append("client_id", process.env.NEXT_PUBLIC_CLIENT_ID || "unknown");
  body.append("subject_token", actionToken);
  body.append("subject_token_type", "urn:ietf:params:oauth:token-type:jwt");

  const result = await client(
    `${process.env.NEXT_PUBLIC_IAM_HOST}/auth/realms/nju/protocol/openid-connect/token`,
    {
      method: "post",
      validator: serverResponse,
      doNotRefreshTokenOn401: true,
      headers: {
        "Accept-Language": "pl",
        Cookie: "KEYCLOAK_LOCALE=pl",
      },
      body,
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  const now = Date.now();

  const output = {
    accessToken: result.value.access_token,
    refreshToken: result.value.refresh_token,
    accessTokenExpirationDate: now + result.value.expires_in * 1000,
    refreshTokenExpirationDate: now + result.value.refresh_expires_in * 1000,
  };

  setAuthInfoInStorage(output, "portal");

  const userInfo = await info();

  if (isOk(userInfo)) {
    Bugsnag.setUser(
      userInfo.value.id,
      userInfo.value.email,
      `${userInfo.value.firstName} ${userInfo.value.lastName}`,
    );
  }

  return ok(output);
}
